import { Injectable, inject } from '@angular/core';
import { ModalService } from 'src/shared/modal/modal.service';
import {
  TemplateLogOverlayComponent,
  TemplateLogOverlayOptions,
} from './template-log-overlay.component';

@Injectable()
export class TemplateLogOverlayService {
  private modal = inject(ModalService)


  showLogs(templateId: string) {
    return this.modal.openDialog<
      TemplateLogOverlayComponent,
      TemplateLogOverlayOptions,
      void
    >(
      TemplateLogOverlayComponent,
      {
        title: `Template Log`,
        templateId,
      },
      {
        panelClass: ['tc-dialog', 'modal-xlg'],
        width: null,
        maxWidth: null,
      }
    );
  }
}